<template>
	<div class="segmented-toggle" role="group">
		<button
			v-for="option in options"
			:key="option.value"
			type="button"
			class="option"
			:class="{ active: modelValue === option.value }"
			:aria-pressed="modelValue === option.value"
			@click="emit('update:modelValue', option.value)"
		>
			<AppIcon :name="option.icon" />
			<span>{{ option.label }}</span>
		</button>
	</div>
</template>

<script setup lang="ts" generic="T extends string">
import AppIcon from "@/components/AppIcon.vue"
import type { IconName } from "@/components/icons/registry"

defineProps<{
	modelValue: T
	options: { value: T; label: string; icon: IconName }[]
}>()

const emit = defineEmits<{
	"update:modelValue": [T]
}>()
</script>

<style scoped>
.segmented-toggle {
	display: flex;
	align-items: center;
	gap: var(--spacing-xxs);
	padding: var(--spacing-xxs);
	background-color: var(--neutral-0);
	border-radius: var(--border-radius-full);

	.option {
		display: flex;
		flex: 1;
		align-items: center;
		justify-content: center;
		gap: var(--spacing-sm);
		padding: var(--spacing-sm) var(--spacing-lg);
		border: none;
		border-radius: var(--border-radius-full);
		background: transparent;
		color: var(--neutral-600);
		font-family: var(--font-family-primary);
		font-size: var(--font-size-regular);
		font-weight: var(--font-weight-medium);
		white-space: nowrap;
		cursor: pointer;

		&:hover:not(.active) {
			color: var(--neutral-900);
		}

		&.active {
			background-color: var(--primary-green);
			color: var(--neutral-0);
		}
	}
}
</style>
